import { Http } from "./create-axios.js";
import { Notification } from "element-ui";
import { sm2 } from "sm-crypto";
import Vue from "vue";
import router from "../router/index.js";
// 请求拦截
function handleResquest(config) {
  // headers 设置
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  config.headers["Accept"] = "application/json";

  config.headers["X-ZNGY-TOKEN"] = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : "1";
  config.headers["X-Gray"] = localStorage.getItem("X-Gray")
    ? localStorage.getItem("X-Gray")
    : "";

  // 添加租户ID到请求头
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  if (userInfo && userInfo.tenantId) {
    config.headers["X-Tenant-Id"] = userInfo.tenantId;
  }

  let content = JSON.stringify(config.data);
  // config.data = {
  //   data: "04" + sm2.doEncrypt(content, process.env.VUE_APP_PUBLIC_KEY, 1),
  // };
  // console.log(config.url);
  // console.log(content);//--接口数据
  if (
    config.method == "post" &&
    content != undefined &&
    config.url.indexOf("common/upload") < 0 &&
    config.url.indexOf("/web/employee/exportEmployeeDataByFile") < 0 &&
    config.url.indexOf("/file/upload") < 0 &&
    config.url.indexOf("/shop/shopApplyBasicWordExport") < 0 &&
    config.url.indexOf("/web/pipeManage/uploadExcel/line") < 0 &&
    config.url.indexOf("/web/pipeManage/uploadExcel/well") < 0 &&
    config.url.indexOf("/web/azl/urlDirect") < 0
  ) {
    // console.log("加密了");
    config.headers["Content-Type"] = "application/json";
    config.data = {
      data: "04" + sm2.doEncrypt(content, process.env.VUE_APP_PUBLIC_KEY, 1),
    };
  } else if (config.url.indexOf("/web/azl/urlDirect") > -1) {
    // console.log("未加密");
    config.headers["Content-Type"] = "application/json";
  } else {
    config.headers["Content-Type"] = "multipart/form-data";
  }
  return config;
}

// 响应拦截
function responseHandle(response, error) {
  // console.log("response");
  // console.log(response);
  if (response.data.code == 401) {
    localStorage.clear();
    router.push("/login");
    // location.reload(true);
  }
  if (!error) {
    let dataOrigin = response.data.data;
    try {
      if (
        dataOrigin != null &&
        dataOrigin.length > 2 &&
        response.config.url != "/portal/label/tree" &&
        response.config.url != "/web/azl/urlDirect" &&
        response.config.url != "web/gis/pipeGeomInfo2"
      ) {
        let dataDecode = sm2.doDecrypt(
          dataOrigin.substring(2),
          process.env.VUE_APP_PRIVATE_KEY,
          1,
        );
        if (dataDecode != null) {
          response.data.data = JSON.parse(dataDecode);
        }
      } else {
        response.data.data = dataOrigin;
      }
    } catch (err) {}
    // console.log(response.data);//--接口返回数据
    return response;
  }

  if (error.toString().indexOf("timeout") > -1) {
    const res = {
      data: {
        Code: "500002",
        Msg: "timeout",
      },
    };
    Notification.error({
      title: "错误提示",
      message: "请求超时！",
    });
    return res;
  }

  const res = {
    data: {
      Code: "500001",
      Msg: "Server error",
    },
  };
  // Notification.error({
  //     title: "错误提示",
  //     message: "网络错误请重试！"
  // });
  return res;
}
// 实例方法
export const http = new Http({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 60000,
  requestHandle(config) {
    return handleResquest(config);
  },
  responseHandle(response, err) {
    return responseHandle(response, err);
  },
});
